import { useContext } from 'react';
import AuthContext from 'src/contexts/LaravelCookieAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
